import React from 'react';
import PropTypes from 'prop-types';
import { Descriptions, Card } from 'antd';
import { DateDisplay } from 'components/layout';
import { getEndorserTitle } from '../utils';

const EndorsementDetail = ({ step }) => {
  const endorserListingType = step?.endorserListingType;
  const appointedEndorser = step?.appointedEndorser;
  return (
    <Card
      type="inner"
      title={`Endorsement by ${getEndorserTitle(
        appointedEndorser,
        endorserListingType
      )}`}
    >
      <Descriptions column={{ xxl: 2, xl: 2, lg: 2, md: 2, sm: 1, xs: 1 }}>
        <Descriptions.Item label="Endorser">
          {step?.endorser?.name}
          {step?.appointedEndorser?.role?.role &&
            ` as ${step?.appointedEndorser?.role?.name}`}
        </Descriptions.Item>
        <Descriptions.Item label="Endorsement date">
          <DateDisplay date={step?.date} />
        </Descriptions.Item>
        <Descriptions.Item label="Decision" span={2}>
          {step?.endorsed
            ? 'Endorsed'
            : step?.endorsed === null
            ? ''
            : 'Not Endorse'}
        </Descriptions.Item>
        <Descriptions.Item label="Comment">{step?.comment}</Descriptions.Item>
      </Descriptions>
    </Card>
  );
};

EndorsementDetail.propTypes = {
  step: PropTypes.object.isRequired,
};

export default EndorsementDetail;
